import React from "react";

const StandalonePage: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div data-testid="cargo-ops-standalone-page" className="pt-8 pb-8 px-24">
    {children}
  </div>
);

export default StandalonePage;
